/**
 * Dispatches a CustomEvent with an optional payload
 *
 * @callback GenEventDispatcher
 * @param {Object} [detail] - An object that will be assigned to the CustomEvent.detail property. If signatureParams were provided to the generator, this object should include properties that match the signature
 * @returns void
 */

/**
 *
 * @param eventName
 * @returns {GenEventDispatcher}
 */
const createEventDispatcher = ({ eventName }) => detail => {
  const pairEvent = new CustomEvent(eventName, {
    detail
  });
  global.dispatchEvent(pairEvent);
};

export default createEventDispatcher;
